// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__NqbkQ","container":"styles_container__3Dyqa","cardContainer":"styles_cardContainer__3weRl"};